import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {
  private modals: any[] = [];
  private dataSubjects: Map<string, Subject<any>> = new Map();

  add(modal: any) {
    // add modal to array of active modals
    this.modals.push(modal);
  }

  remove(id: string) {
    // remove modal from array of active modals
    this.modals = this.modals.filter(x => x.id !== id);
  }

  open(id: string, data?: any) {
    const modal = this.modals.find(x => x.id === id);
    if (modal) {
      modal.data = data;

      // Emitimos el nuevo dato para que los suscriptores lo reciban
      if (!this.dataSubjects.has(id)) {
        this.dataSubjects.set(id, new Subject<any>());
      }
      this.dataSubjects.get(id)!.next(data);

      modal.open(); // Llamamos a la función original de abrir modal
    }
  }

  close(id: string, returnValue?: any) {
    const modal = this.modals.find((x) => x.id === id);
    if (modal) {
      modal.close();

      // Emitimos el valor cuando se cierra el modal
      if (this.dataSubjects.has(id)) {
        this.dataSubjects.get(id)!.next(returnValue);
      }
    }
  }

  exists(id: string) {
    return this.modals.filter(x => x.id === id)[0];
  }

  isOpen(id: string) {
    const modal = this.modals.filter(x => x.id === id)[0];
    return modal.alive;
  }

  getData(id: string): Observable<any> {
    if (!this.dataSubjects.has(id)) {
      this.dataSubjects.set(id, new Subject<any>());
    }
    return this.dataSubjects.get(id)!.asObservable();
  }

  get(id: string): any {
    return this.modals.find(x => x.id === id);
  }
}
